import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=092e8a49"
import script from "./BasicPage.vue?vue&type=script&lang=js"
export * from "./BasicPage.vue?vue&type=script&lang=js"
import style0 from "./BasicPage.vue?vue&type=style&index=0&id=092e8a49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports